import React, { useState, useEffect } from "react";
import Gallery from 'react-image-gallery'; // Import the gallery component
import 'react-image-gallery/styles/css/image-gallery.css';
import { useParams } from "react-router-dom";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
import BookingModal from "../../Components/BookingModal";
function SProductDetail() {
    const [data, setData] = useState([]);
    const [imagesList, setImagesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    useEffect(() => {
        const fetchApiData = async () => {
            const url = "api/solar/specification/" + id;
            const result = await fetchData(url);
            if (result && result.data) {
                const images = result.data.media.map(item => ({
                    original: item.original_url,
                    thumbnail: item.original_url
                }));
                setImagesList(images)
                setData(result.data);
            }
            setLoading(false);
        };
        fetchApiData();
    }, [id]);
    const responsive = [
        {
            breakpoint: 1024, // Tablets and large mobile devices
            settings: {
                slidesToShow: 3,  // Display 3 images at a time on medium screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768, // Small devices (e.g. mobile phones)
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on mobile screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480, // Very small screens
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on very small screens
                slidesToScroll: 1,
            },
        },
    ];
    return (
        <div className="container my-5">
            {loading && <MainLoader />}
            <div className="mt-4">
                {/* Modern Header */}
                <div className="brand-banner py-5 px-3 text-center text-white mb-4">
                    <h1 className="display-4 fw-bold mb-2"><span className="brand-name">{data?.title}</span></h1>
                    <p className="lead">{data?.short_description}</p>
                </div>
            </div>

            <div className="row mt-3 bg-light p-2">
                <div className="col-md-12 p-2 text-center">
                    <img className="w-75" src={data?.media ? data.media[0]?.original_url : ''} />
                </div>
            </div>
            <div className="mt-5 varient-detail">

                <div class="title-wrapper d-flex mb-30">
                    <h4 class="mb-0 flex-shrink-0"> Solar Inverter</h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table border rounded mt-3 ">
                        <tbody>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Inverter Model</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.inverter_model}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Inverter Type</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.inverter_type}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Rated Output Power</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.rate_output_power}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">DC Input Voltage Range</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.dc_input_voltage_range}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">MPPT Range</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.mppt_range}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Number of MPPTs</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.number_of_mppts}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Max DC Input Current</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.max_dc_input_current}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">AC Output Voltage</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.ac_output_voltage}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Output Frequency</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.output_frequency}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Inverter Efficiency</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.inverter_efficiency}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Battery Compatibility</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.battery_compatibility}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Communication Interface</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.communication_interface}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Operating Temperature</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.operating_temperature}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Protection Feature</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.protection_feature}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Inverter Warranty</p>
                                        <p className="pb-0 mb-0">{data.solarinverter?.inverter_warrenty}</p>
                                    </div>
                                </td>
                            </tr>


                        </tbody>
                    </table>
                </div> */}
                <div className="teble-td-inherit mt-3">
                    <div className="row g-3">

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Inverter Model</p>
                                <p className="mb-0">{data.solarinverter?.inverter_model}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Inverter Type</p>
                                <p className="mb-0">{data.solarinverter?.inverter_type}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Rated Output Power</p>
                                <p className="mb-0">{data.solarinverter?.rate_output_power}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>DC Input Voltage Range</p>
                                <p className="mb-0">{data.solarinverter?.dc_input_voltage_range}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>MPPT Range</p>
                                <p className="mb-0">{data.solarinverter?.mppt_range}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Number of MPPTs</p>
                                <p className="mb-0">{data.solarinverter?.number_of_mppts}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Max DC Input Current</p>
                                <p className="mb-0">{data.solarinverter?.max_dc_input_current}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>AC Output Voltage</p>
                                <p className="mb-0">{data.solarinverter?.ac_output_voltage}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Output Frequency</p>
                                <p className="mb-0">{data.solarinverter?.output_frequency}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Inverter Efficiency</p>
                                <p className="mb-0">{data.solarinverter?.inverter_efficiency}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Battery Compatibility</p>
                                <p className="mb-0">{data.solarinverter?.battery_compatibility}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Communication Interface</p>
                                <p className="mb-0">{data.solarinverter?.communication_interface}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Operating Temperature</p>
                                <p className="mb-0">{data.solarinverter?.operating_temperature}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Protection Feature</p>
                                <p className="mb-0">{data.solarinverter?.protection_feature}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Inverter Warranty</p>
                                <p className="mb-0">{data.solarinverter?.inverter_warrenty}</p>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0"> Solar Panel</h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table border rounded mt-3 ">
                        <tbody>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Panel Model</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.panel_model}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Panel Type</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.panel_type}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Panel Efficiency</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.panel_efficiency}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Rated Power</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.rate_power}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Current Max Power</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.current_max_power}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Voltage Max Power</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.voltage_max_power}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Short Circuit Current</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.short_circuit_current}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Open Circuit Voltage</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.open_circuit_voltage}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Cell Configuration</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.cell_configuration}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Temperature Coefficient</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.temperature_coifficent}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Glass Type</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.glass_type}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Frame Material</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.frame_material}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Weight</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.weight}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Dimensions</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.diminsion}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Panel Warranty</p>
                                        <p className="pb-0 mb-0">{data.solarpanel?.panel_warrenty}</p>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div> */}
                <div className="teble-td-inherit mt-3">
                    <div className="row g-3">

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Panel Model</p>
                                <p className="mb-0">{data.solarpanel?.panel_model}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Panel Type</p>
                                <p className="mb-0">{data.solarpanel?.panel_type}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Panel Efficiency</p>
                                <p className="mb-0">{data.solarpanel?.panel_efficiency}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Rated Power</p>
                                <p className="mb-0">{data.solarpanel?.rate_power}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Current Max Power</p>
                                <p className="mb-0">{data.solarpanel?.current_max_power}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Voltage Max Power</p>
                                <p className="mb-0">{data.solarpanel?.voltage_max_power}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Short Circuit Current</p>
                                <p className="mb-0">{data.solarpanel?.short_circuit_current}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Open Circuit Voltage</p>
                                <p className="mb-0">{data.solarpanel?.open_circuit_voltage}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Cell Configuration</p>
                                <p className="mb-0">{data.solarpanel?.cell_configuration}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Temperature Coefficient</p>
                                <p className="mb-0">{data.solarpanel?.temperature_coifficent}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Glass Type</p>
                                <p className="mb-0">{data.solarpanel?.glass_type}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Frame Material</p>
                                <p className="mb-0">{data.solarpanel?.frame_material}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Weight</p>
                                <p className="mb-0">{data.solarpanel?.weight}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Dimensions</p>
                                <p className="mb-0">{data.solarpanel?.diminsion}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Panel Warranty</p>
                                <p className="mb-0">{data.solarpanel?.panel_warrenty}</p>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0">Accessorie</h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table border rounded mt-3 ">
                        <tbody>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">AC Cable</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.ac_cable}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">DC Cable</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.dc_cable}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Battery</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.battery}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Charge Controller</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.charge_controller}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Combine Box</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.combine_box}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Connector</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.connector}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Fuses / Breaker</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.fuses_breaker}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Surge Protector</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.surge_protector}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Mounting Structure</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.mounting_structure}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Monitoring Device</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.monitoring_device}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Earthing Kit</p>
                                        <p className="pb-0 mb-0">{data.accessorie?.earthing_kit}</p>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div> */}
                <div className="teble-td-inherit mt-3">
                    <div className="row g-3">

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>AC Cable</p>
                                <p className="mb-0">{data.accessorie?.ac_cable}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>DC Cable</p>
                                <p className="mb-0">{data.accessorie?.dc_cable}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Battery</p>
                                <p className="mb-0">{data.accessorie?.battery}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Charge Controller</p>
                                <p className="mb-0">{data.accessorie?.charge_controller}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Combine Box</p>
                                <p className="mb-0">{data.accessorie?.combine_box}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Connector</p>
                                <p className="mb-0">{data.accessorie?.connector}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Fuses / Breaker</p>
                                <p className="mb-0">{data.accessorie?.fuses_breaker}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Surge Protector</p>
                                <p className="mb-0">{data.accessorie?.surge_protector}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Mounting Structure</p>
                                <p className="mb-0">{data.accessorie?.mounting_structure}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Monitoring Device</p>
                                <p className="mb-0">{data.accessorie?.monitoring_device}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Earthing Kit</p>
                                <p className="mb-0">{data.accessorie?.earthing_kit}</p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="mt-4 d-flex justify-content-between text-end">
                    <BookingModal ProductDetail={data} />
                    <h3>Price : {data?.price}</h3>
                </div>
            </div>
        </div>
    )
}

export default SProductDetail;